import { Col, Container, Row, Modal, Form } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import product_img from '../../../Assets/images/home/shopbystyle_3.jpg'
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ErrorImg, base_url, postHeader } from "../../../Helper/request";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { cartlength, showcartlist } from '../../../Reducer/cartReducer';
import { showaccount } from '../../../Reducer/homeReducer';
import pdp_freegift_dummy from "../../../Assets/images/pdp_freegift_dummy.jpg";
import { IoIosArrowRoundBack } from "react-icons/io"
import SalesTax from './SalesTax';
import { promo } from '../../../Assets/svg';
import Engravings from './Engravings';
const Cart = ({ popup }) => {

  const [freeGiftShow, setfreeGiftShow] = useState(false);
  const freeGift_handleClose = () => setfreeGiftShow(false);
  const freeGift_handleShow = () => setfreeGiftShow(true);
  const [freeGiftDec, setfreeGiftDec] = useState(false);

  const dispatch = useDispatch();
  const home = useSelector(state => state.persistedReducer.home)
  const cartlen = useSelector((state) => state.persistedReducer.cart?.cartlengthvalue);
  const userdata = useSelector(state => state.persistedReducer.home.user)
  const islogin = useSelector(state => state.persistedReducer.home.isLogin)
  const session_id = useSelector(state => state.persistedReducer.home.session_id)
  const [cartData, setCartData] = useState([])
  const [customfield, setCustomfield] = useState(false)
  const [ringsize, setRingsize] = useState("");
  const [outofstock, setOutofstock] = useState(false);


  useEffect(() => {
    if (window.location.pathname == "/cart") {
      dispatch(showcartlist(false));
    }
    cartlistapi();
    return () => {
      popup = true;
    }
  }, [])
  // ga4 view_cart---------start
  const Cart_ListProductEvent = (product) => {
    const gaProducts = product?.cart_data?.map(product => ({
      item_id: product.cart_id,
      item_name: product.name,
      price: product.price
    }));
    if (window.gtag) {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('event', 'view_cart', {
        event: 'view_cart',
        ecommerce: {
          currency: "USD",
          value: gaProducts?.price,
          items: [gaProducts]
        }
      });
    }
  };
  // ga4 view_cart---------End
  const cartlistapi = () => {
    const data = {
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      token: userdata?.token ? userdata?.token : ""
    }
    axios.post(base_url + '/order/cart_list', data, {
      headers: postHeader
    })
      .then(response => {
        if (response.data.status == 1) {
          setCartData(response.data.data);
          Cart_ListProductEvent(response.data.data)
          var outofstockitem = response.data.data?.cart_data?.filter(val => val?.is_in_stock == false)
          setOutofstock(outofstockitem.length ? true : false)
        } else {
          console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // klaviyo add to viewed product event
  async function kleviyoTracking(params) {
    var item = {
      ProductName: params?.name,
      ProductID: params?.product_id,
      SKU: params?.sku,
      ImageURL: params?.url,
      URL: window.location.href,
      Price: params?.price,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Remove From Cart", item]);
    }
  }
  // klaviyo add to cart event start
  // ga4 remove_from_cart---------start
  const Remove_CartProductEvent = (val) => {
    const gaProducts = {
      item_id: val.cart_id,
      item_name: val.name,
      price: val.price
    };
    if (window.gtag) {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('event', 'remove_from_cart', {
        event: 'remove_from_cart',
        ecommerce: {
          currency: "USD",
          value: val?.price,
          items: [gaProducts]
        }
      });
    }
  };
  // ga4 remove_from_cart---------End
  const deleteData = (val, cart_id) => {
    Remove_CartProductEvent(val)
    kleviyoTracking(val)
    const data = {
      cart_id,
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      token: userdata?.token ? userdata?.token : ""
    }
    axios.post(base_url + '/order/remove_cart', data, {
      headers: postHeader
    })
      .then(response => {
        if (response.data.status == 1) {
          dispatch(cartlength(response.data.data.total_count));
          cartlistapi();
        } else {
          console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const updateData = (cart_id, ring_size) => {
    const data = {
      cart_id,
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      token: userdata?.token ? userdata?.token : "",
      ring_size
    }
    axios.post(base_url + '/order/update_cart', data, {
      headers: postHeader
    })
      .then(response => {
        if (response.data.status == 1) {
          dispatch(cartlength(response.data.data.total_count));
          cartlistapi()
        } else {
          console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const stoneQualtiyHandle = (val) => {
    if (val && val !== "") {
      return "?stone_quality=" + val.replaceAll("+/", "%2B%2F")
    } else {
      return "/"
    }
  }
  return (
    <> {
      popup == false ?
        <section className={`${ Number(cartlen) > 0 ? "cart-page" : "my-5"}`}>
          <Container>

            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Shopping Cart</Breadcrumb.Item>
            </Breadcrumb>

            {
              Number(cartlen) > 0 ? <Row className='mt-lg-4'>
                <Col md={7} lg={8}>
                  <div className='shopping-cart-product-box'>
                    <h1 className='title'> Shopping Cart</h1>
                    <div className='added_products_list'>

                      {cartData?.cart_data?.map((val, index) =>
                        <div className='single-product-box'>
                          <Link to={`/product-detail/${val?.group_id}/${val?.slug}${val?.stone_quality && val?.stone_quality !== ""
                              ? "/" + encodeURI(val?.stone_quality).replaceAll("+/", "%2B%2F")
                              : "/"
                            }`}><img id={"img-" + index} onError={() => ErrorImg("img-" + index)} src={val.url} alt='Ring' className='product-img' /></Link>
                          <div className='product-detail'>

                            <div className='buy-product'>
                              <h3 className='product-name'><Link to={`/product-detail/${val?.group_id}/${val?.slug}${val?.stone_quality && val?.stone_quality !== ""
                                  ? "/" + encodeURI(val?.stone_quality).replaceAll("+/", "%2B%2F")
                                  : "/"
                                }`}>{val.name}</Link>
                                <div className='product-qty'>
                                  <h5 className='product-qty-title'>QTY: <span>{val.quantity}</span></h5>
                                  {/* <div className='qty-select'>
                <select className='shopping-cart_select'>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
                <span className="filter-dropdown-arrow"></span>
              </div> */}
                                </div>
                              </h3>
                              <p className='product-description-text'>{val.description}</p>
                              <h5 className='product-SKU'>{val.sku}{val?.stone_quality.length ? `-${val?.stone_quality}` : ""}</h5>
                              {val?.ring_sizes?.length ? <>
                                <div className='ringsize-select'>
                                  <select value={(val?.ring_sizes?.includes(val?.ring_size) && !customfield) ? val?.ring_size : "Custom"}
                                    onChange={(e) => { if (e.target.value == "Custom") { setCustomfield(true) } else { setCustomfield(false); updateData(val.cart_id, e.target.value); } }}
                                    className='shopping-cart_select'>
                                    {val?.ring_sizes?.map(val1 =>
                                      <option value={val1}>{val1}</option>
                                    )}
                                  </select>
                                  {/* <span className="filter-dropdown-arrow"></span> */}
                                </div>
                                {!val?.ring_sizes?.includes(val?.ring_size) || customfield ?
                                  <input type='number' value={customfield ? ringsize : val?.ring_size} onBlur={() => updateData(val.cart_id, ringsize)} onChange={(e) => { if (e.target.value > 0 && e.target.value < 100) { setRingsize(e.target.value); } }} className='shopping-cart_select' /> :
                                  ""}
                              </> : ""
                              }
                              <h4 className='product-price'>${val?.sale_price}</h4>

                              {val?.is_engraving ?
                                <div className='my-3'>

                                  <Engravings
                                    val={val}
                                    cartlistapi={cartlistapi}
                                    userdata={userdata}
                                    session_id={session_id}
                                  />
                                </div>
                                : ""}
                              {val?.is_in_stock ? "" : <h4 className='product-price' style={{ color: "red" }}>Out of Stock </h4>}

                              <button onClick={() => deleteData(val, val?.cart_id)} className='remove_product'>Remove</button>
                            </div>
                          </div>
                        </div>
                      )}
                      {/*  product free protection plan */}
                      <div className='free-product'>
                        <h3 className='product-name'> FREE Lifetime Protection Plan
                          <div className='product-qty'>
                            <h5 className='m-0'>QTY: <span>1</span></h5>
                          </div>
                        </h3>
                        <Link to="/customer-service/our-warranty" className='learn-more'>Learn More</Link>
                      </div>

                      {/* Free Product */}
                      {cartData?.offer_product?.length ?

                        <div className='single-product-box'>
                          <Link style={{ cursor: 'pointer' }} onClick={freeGift_handleShow} ><img src={cartData?.offer_product[0]?.img} alt='Ring' className='product-img' /></Link>
                          <div className='product-detail'>

                            <h3 style={{ cursor: 'pointer' }} onClick={freeGift_handleShow} className='product-name'> {cartData?.offer_product[0]?.name}
                              <div className='product-qty'>
                                <h5 className='m-0'>QTY: <span>1</span></h5>
                              </div>
                            </h3>
                            {/* <h5 className='product-descreption'>With Purchase of $1,000 or more</h5> */}
                            {/* <div className='color-select'>
              <select className='shopping-cart_select'>
                {cartData?.offer_product[0]?.metal_colors?.map(val =>
                  <option value={val.value}>{val.name}</option>
                )}
              </select>
              <span className="filter-dropdown-arrow"></span>
            </div> */}
                          </div>
                        </div>
                        : ""}
                    </div>
                  </div>
                </Col>

                <Col md={5} lg={4}>
                  <div className='shopping-cart-order-summury'>
                    <h1 className='title'> Order Summary</h1>
                    <div className='order-summury-innerbox'>
                      <ul className='amount-box'>
                        <li>Subtotal  <span>${cartData?.sub_total}</span></li>
                        {cartData?.total_engraving_charges > 0 ? <li>Engraving Charges  <span>${cartData?.total_engraving_charges}</span></li> : ""}
                        <li>Shipping   <span>{cartData?.shipping ? cartData?.shipping : 'FREE'}</span></li>
                        {/* <li>Sales Tax  <span>{cartData?.tax}</span></li> */}
                        {/* <SalesTax state="" total={cartData?.tot_sale_price}/> */}
                      </ul>

                      <ul className='total-box'>
                        <li>TOTAL   <span>${cartData?.tot_sale_price}</span></li>
                      </ul>
                      {islogin ?
                        outofstock ? <Link to="#" style={{ opacity: 0.5, pointerEvents: 'none' }} className='theme_btn mt-5' >Checkout</Link> : <Link to="/checkout" className='theme_btn mt-5'>Checkout</Link> :
                        <>
                          <Link to="#" onClick={() => dispatch(showaccount(!home?.showaccount))} className='theme_btn mt-5 mb-0'>Login</Link>
                          <Link to="/checkout" className='theme_btn mt-3' >Guest Checkout</Link>
                        </>
                      }
                    </div>


                    <div className='shipping-detail'>
                      <h1 className='title mb-3'>Shipping</h1>
                      <p>{cartData?.shipping_estimated_label}</p>
                    </div>
                    <div className='back-to-shop'>
                      <p className='mb-4'>Need to take another look?</p>
                      <Link to="/productlist/engagement-rings" className='theme_btn'>Continue Shopping</Link>
                    </div>
                  </div>
                </Col>
              </Row> : <section className='my-5'>
                <Container>

                  <Row className='justify-content-center'>
                    <Col md={7} lg={6} xl={5} sm={7}>
                      <div className='underWrapper shadow text-center p-5 mb-5'>
                        <h2 className='fontLora colorPrimary'>Your Cart is empty</h2>
                        <p className='greenText'>You have not added anything to your cart</p>
                        <div className='mt-5'>
                          <Link className='theme_btn_light text-center' to="/productlist/engagement-rings">Continue Shopping</Link>
                        </div>
                      </div>
                    </Col>
                  </Row>


                </Container>
              </section>
            }



          </Container>
        </section>
        :
        <div className='shopping-checkout-order-summury'>
          <div className='shopping-cart-product-box'>

            <div className='added_products_list p-0'>
              {cartData?.cart_data?.map((val, index) =>
                <div className='single-product-box'>
                  {/* remove product */}
                  <span className='remove-product' onClick={() => deleteData(val, val?.cart_id)}>x</span>
                  <Link to={"/product-detail/" + val.group_id + "/" + val.slug}><img id={"img-" + index} onError={() => ErrorImg("img-" + index)} src={val.url} alt={val.name} className='product-img' /></Link>
                  <div className='product-detail'>
                    <div className='buy-product'>
                      <h3 className='product-name'><Link to={"/product-detail/" + val.group_id + "/" + val.slug + stoneQualtiyHandle(val?.stone_quality)}> {val.name}</Link></h3>
                      <div className='product-qty'>
                        <h5 className='m-0'>QTY: <span>{val.quantity}</span></h5>
                      </div>
                      <h4 className='product-price'>${val.price}</h4>
                      {val.is_in_stock ? "" : <h4 className='product-price' style={{ color: "red" }}>Out of Stock</h4>}
                    </div>
                  </div>
                </div>
              )}
              {/*  product free protection plan */}
              <div className='free-product'>
                <h3 className='product-name'> FREE Lifetime Protection Plan</h3>
                <Link to="/customer-service/our-warranty" className='learn-more'>Learn More</Link>
              </div>
              {cartData?.offer_product?.length ?
                <div className='single-product-box'>
                  <Link to="/"><img src={cartData?.offer_product[0]?.img} alt='Ring' className='product-img' /></Link>
                  <div className='product-detail'>

                    <h3 className='product-name'> {cartData?.offer_product[0]?.name}
                    </h3>
                    {/* <h5 className='product-descreption'>With Purchase of $1,000 or more</h5> */}
                  </div>
                </div>
                : ""}
            </div>
          </div>
          <div className='shopping-cart-order-summury'>
            <div className='order-summury-innerbox'>
              {cartData?.tot_sale_price != undefined ? <ul className='total-box'>
                <li>SUBTOTAL   <span>${cartData?.tot_sale_price}</span></li>
              </ul> : ""}
              <Link to="/cart" className='theme_btn'>Checkout</Link>
            </div>

          </div>
        </div>
    }

      {/* Free Gift modal */}

      <Modal
        show={freeGiftShow}
        onHide={freeGift_handleClose}
        className="send_hint freeGift_modal"
        size="lg"
        centered
        backdropClassName="green-backdrop"
      >
        <span onClick={freeGift_handleClose} className="sent-hint-close">x</span>
        <Modal.Body>
          {cartData?.offer_product?.length ?
            <div className="send_hint_head">
              <Row className={freeGiftDec == true ? "d-none" : ""}>
                <Col md={3} xs={4}>
                  <img src={cartData?.offer_product[0]?.img} alt="Free Gift" className="img-fluid" />
                </Col>
                <Col md={9} xs={8}>
                  <h3>{cartData?.offer_product[0]?.name}</h3>
                  <p>{cartData?.offer_product[0]?.description?.substring(0, 260)} <span onClick={() => setfreeGiftDec(true)}>Learn More</span></p>
                </Col>
              </Row>
              {/* <hr className={freeGiftDec == true ? "d-none" : "bg-light-hr"}/>
            <Row className={freeGiftDec == true ? "d-none" : ""}>
              <Col md={3} xs={4}>
                <img src={cartData?.offer_product[0]?.img} alt="Free Gift" className="img-fluid" />
              </Col>
              <Col md={9} xs={8}>
                <h3>{cartData?.offer_product[0]?.name}</h3>
                <p>Fine Print: Offer valid online and in store now through 10/15/2023 on purchases that equal at least $1500 before tax. Not valid on previous purchases, layaway repairs or other services. Cannot be combined with any other offers. Eligible customers will receive only one necklace, <span onClick={()=>setfreeGiftDec(true)}>Learn More</span></p>
              </Col>
            </Row> */}
              <div className={freeGiftDec == true ? "detail_desc" : "d-none"}>
                <IoIosArrowRoundBack onClick={() => setfreeGiftDec(false)} />
                <Row>
                  <Col md={3}>
                    <img src={cartData?.offer_product[0]?.img} alt="Free Gift" className="img-fluid" />
                  </Col>
                  <Col md={9}>
                    <h3>{cartData?.offer_product[0]?.name}</h3>
                    <p>{cartData?.offer_product[0]?.description}</p>
                  </Col>
                </Row>
              </div>
            </div>
            : ""}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Cart